export const colorsRGB = [
  {id: 'zero', r: 255, g:255, b:255},
  {id: 'one', r: 248, g:252, b:251},
  {id: 'two', r: 255, g:251, b:235},
  {id: 'three', r: 255, g:253, b:203},
  {id: 'four', r: 255, g:252, b:155},
  {id: 'five', r: 245, g:221, b:97},
  {id: 'six', r: 255, g:195, b:116},
  {id: 'seven', r: 255, g:163, b:60},
  {id: 'eight', r: 236, g:143, b:94},
  {id: 'nine', r: 235, g:196, b:159},
  {id: 'ten', r: 229, g:194, b:135},
  {id: 'eleven', r: 198, g:169, b:105},
  {id: 'twelve', r: 255, g:230, b:230},
  {id: 'thirteen', r: 255, g:190, b:152},
  {id: 'fourteen', r: 234, g:144, b:108},
  {id: 'fifteen', r: 255, g:192, b:217},
  {id: 'sixteen', r: 252, g:129, b:158},
  {id: 'seventeen', r: 255, g:144, b:188},
  {id: 'eighteen', r: 159, g:112, b:253},
  {id: 'nineteen', r: 127, g:39, b:255},
  {id: 'twenty', r: 73, g:46, b:135},
  {id: 'twentyone', r: 255, g:104, b:104},
  {id: 'twentytwo', r: 191, g:49, b:49},
  {id: 'twentythree', r: 154, g:3, b:30},
  {id: 'twentyfour', r: 197, g:235, b:170},
  {id: 'twentyfive', r: 121, g:172, b:120},
  {id: 'twentysix', r: 41, g:75, b:41},
  {id: 'twentyseven', r: 200, g:255, b:224},
  {id: 'twentyeight', r: 150, g:233, b:198},
  {id: 'twentynine', r: 21, g:245, b:186},
  {id: 'thirty', r: 154, g:208, b:194},
  {id: 'thirtyone', r: 45, g:149, b:150},
  {id: 'thirtytwo', r: 38, g:80, b:115},
  {id: 'thirtythree', r: 103, g:198, b:227},
  {id: 'thirtyfour', r: 55, g:140, b:231},
  {id: 'thirtyfive', r: 83, g:86, b:255},
  {id: 'thirtysix', r: 223, g:168, b:120},
  {id: 'thirtyseven', r: 236, g:177, b:89},
  {id: 'thirtyeight', r: 182, g:115, b:82}
]